import styled, { css } from 'styled-components';
import * as Styles from '../../utils/styleUtils';
import hsliderIcon from '../../../../../images/editor/buttons/hslider.png';
import vsliderIcon from '../../../../../images/editor/buttons/vslider.png';

export const SliderLayout = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: ${({ orientation }) => (orientation === 'vertical' ? 'row' : 'column')};
  gap: 6px;
`;

export const LabelsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  flex-direction: ${({ orientation }) => (orientation === 'vertical' ? 'column' : 'row')};
  width: ${({ orientation }) => (orientation === 'vertical' ? '30px' : '100%')};
  height: ${({ orientation }) => (orientation === 'vertical' ? '100%' : 'auto')};
`;

export const TicksAndTrackWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: ${({ orientation }) => (orientation === 'vertical' ? 'row' : 'column')};
  gap: 8px;
`;

export const TicksContainer = styled.div`
  position: relative;
  flex-shrink: 0;
  height: ${({ orientation }) => (orientation === 'vertical' ? '100%' : '4px')};
  width: ${({ orientation }) => (orientation === 'horizontal' ? '100%' : '4px')};
`;

export const SliderTrack = styled.div`
  position: relative;
  background-color: ${({ styleProps }) => styleProps.sliderColor};
  width: ${({ orientation }) => (orientation === 'vertical' ? '4px' : '100%')};
  height: ${({ orientation }) => (orientation === 'vertical' ? '100%' : '4px')};
  border: 1px solid #000;
`;

export const SliderHandle = styled.img.attrs(props => ({
  src: props.orientation === 'vertical' ? vsliderIcon : hsliderIcon,
  style: {
    top: props.orientation === 'vertical' ? `${props.positionPercent}%` : '6px',
    left: props.orientation === 'horizontal' ? `${props.positionPercent}%` : '6px',
  }
}))`
  position: absolute;
  transform: translate(-50%, -50%);
  width: 13px;
  height: 13px;
  cursor: grab;
`;

export const TickMark = styled.span.attrs(props => ({
  style: {
    top: props.orientation === 'vertical' ? `${props.positionPercent}%` : 'auto',
    left: props.orientation === 'horizontal' ? `${props.positionPercent}%` : 'auto',
  }
}))`
  position: absolute;
  background-color: ${({ color }) => color};
  ${({ orientation }) => orientation === 'horizontal' ? css`
    bottom: 0;
    transform: translateX(-50%);
    width: 2px;
    height: 100%;
  ` : css`
    right: 0;
    transform: translateY(-50%);
    width: 100%;
    height: 2px;
  `}
`;

export const SliderLabel = styled.span`
  ${Styles.FontStyles}
  color: ${({ styleProps }) => styleProps.scaleColor};
  font-size: 12px;
  white-space: nowrap;
`;